import { addNotification } from '@redux/features/notificationsSlice';
import { replaceEntries } from '@redux/features/entriesSlice';
import { updateUserStatus } from '@redux/features/usersSlice';
import { updateSession } from '@redux/features/sessionsSlice';
import { logoutUser } from '@redux/features/authSlice';
import TokenService from 'utils/TokenUtils';

let socket = null;
let reconnectTimeout = null;
let lastActivitySent = 0;
const THROTTLE_MS = 1000;
let socketCleanup = null;

const initWebSocket = (dispatch) => {
  const token = TokenService.getToken();
  if (!token) return;

  if (socket) {
    socket.close();
  }

  socket = new WebSocket(`${process.env.REACT_APP_SERVER_WEBSOCKET_URL}?token=${token}`);

  socket.onopen = () => {
    console.log('✅ WebSocket connected');
    if (reconnectTimeout) {
      clearTimeout(reconnectTimeout);
      reconnectTimeout = null;
    }
    sendActivity();
  };

  socket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);

      switch (data.type) {
        case 'update':
          if (data.entries) dispatch(replaceEntries(data.entries));
          break;
        case 'userStatus':
          dispatch(updateUserStatus(data.data));
          break;
        case 'updateSession':
          dispatch(updateSession(data.session));
          break;
        case 'forceLogout':
          dispatch(logoutUser());
          dispatch(addNotification({ id: Math.random(), title: data.reason, type: 'info' }));
          break;
        default:
          console.warn('⚠️ Unknown WS message type:', data.type);
      }
    } catch (error) {
      console.error('❌ Error processing WS message:', error);
    }
  };

  socket.onclose = () => {
    console.log('⚠️ WebSocket disconnected');
    if (!reconnectTimeout) {
      reconnectTimeout = setTimeout(() => initWebSocket(dispatch), 5000);
    }
  };

  socket.onerror = (error) => {
    console.error('❌ WebSocket error:', error);
  };

  const sendActivity = () => {
    const now = Date.now();
    if (socket?.readyState === WebSocket.OPEN && now - lastActivitySent > THROTTLE_MS) {
      socket.send(JSON.stringify({ type: 'online' }));
      lastActivitySent = now;
    }
  };

  const activityEvents = ['mousemove', 'keydown', 'click', 'scroll'];
  activityEvents.forEach((event) => {
    document.addEventListener(event, sendActivity, { passive: true });
  });

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      sendActivity();
    } else {
      if (socket?.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ type: 'offline' }));
      }
    }
  };
  document.addEventListener('visibilitychange', handleVisibilityChange);

  const cleanup = () => {
    if (socket) {
      socket.close();
      socket = null;
    }
    activityEvents.forEach((event) => document.removeEventListener(event, sendActivity));
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    if (reconnectTimeout) clearTimeout(reconnectTimeout);
  };

  socketCleanup = cleanup;
  return cleanup;
};

export const getSocketCleanup = () => socketCleanup;

export default initWebSocket;
